export default function isValidPermalink(str) {
  return !!str.match(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
}
